interface EarnCashBackProps {
  data: any;
}

const EarnCashBackSteps: React.FC<EarnCashBackProps> = ({ data }: any) => {
  return (
    <section className="cashback-stepper">
      {/* <div className="progress" style={{
                width: `${data?.shared <= 20 ? data?.shared * 5 : "100"}%`
            }} />
            <div className="items">
                <div className={`item ${data?.shared >= 1 ? "active" : ''}`}>
                    <span >0</span>
                </div>
                <div className={`item ${data?.shared >= 5 ? "active" : ''}`}>
                    <span >
                        5
                    </span>
                    <span className="item-text">25%</span>
                </div>
                <div className={`item ${data?.shared >= 10 ? "active" : ''}`}>
                    <span >
                        10
                    </span>
                    <span className="item-text">50%</span>
                </div>
                <div className={`item ${data?.shared >= 15 ? "active" : ''}`}>
                    <span>
                        15
                    </span>
                    <span className="item-text">75%</span>
                </div>
                <div className={`item ${data?.shared >= 20 ? "active" : ''}`}>
                    <span>
                        20
                    </span>
                    <span className="item-text">100% Cash Back</span>
                </div>
            </div> */}
      <div
        className="progress"
        style={{
          width: `${data?.shared <= 20 ? data?.shared * 5 : "100"}%`,
        }}
      />
      <div className="items">
        <div className={`item ${data?.shared >= 1 ? "active" : ""}`}>
          <span>0</span>
        </div>
        <div className={`item ${data?.shared >= 5 ? "active" : ""}`}>
          <span>5</span>
          <span className="item-text">$25</span>
        </div>
        <div className={`item ${data?.shared >= 7 ? "active" : ""}`}>
          <span>7</span>
          <span className="item-text">$35</span>
        </div>
        <div className={`item ${data?.shared >= 10 ? "active" : ""}`}>
          <span>10</span>
          <span className="item-text">$50</span>
        </div>
        <div className={`item ${data?.shared >= 15 ? "active" : ""}`}>
          <span>15</span>
          <span className="item-text">$75</span>
        </div>
        <div className={`item ${data?.shared >= 20 ? "active" : ""}`}>
          <span>20</span>
          <span className="item-text" style={{ textAlign: "right" }}>
            $100+
          </span>
        </div>
      </div>
    </section>
  );
};

export default EarnCashBackSteps;
